import { useEffect, useState } from 'react';
import styles from './Navbar.module.css';
import NavbarLinks from './NavbarLinks/NavbarLinks';
import { AppConstants } from '../../AppConstants';
import { InformationData } from '../../data/InformationData';

const Navbar = () => {

    // State for tracking if viewport is mobile-sized
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 890);
    // State for toggling mobile navigation links
    const [showLinks, setShowLinks] = useState(false);
    // State for checking is the page is scrolled or not
    const [isScrolled, setIsScrolled] = useState(false);
    // State for show the active section 
    const [activeSection, setActiveSection] = useState('');
    //state for link clicked or not for window screen < 890
    const [activeLinkClicked, setActiveLinkClicked] = useState(false);

    useEffect(() => {
        if (activeLinkClicked && showLinks) {
            setShowLinks(false); //  It triggers the action to hide the mobile menu.
        }
        const handleResize = () => {
            const mobile = window.innerWidth <= 890;
            setIsMobile(prevMobile => prevMobile !== mobile ? mobile : prevMobile);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [activeLinkClicked, showLinks])

    // useEffect for handle scroll
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        }
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    // useEffect for handle activeSection 
    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.4
        }
        const handleIntersect = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveSection(entry.target.id)
                }
            })
        }
        const observer = new IntersectionObserver(handleIntersect, options);
        const sections = document.querySelectorAll('section')
        sections.forEach(section => {
            observer.observe(section);
        })

        return () => {
            sections.forEach(section => {
                observer.unobserve(section);
            })
        }
    }, [])


    // Function to handle scrolling to a section
    const handleSectionClick = (event) => {
        event.preventDefault();
        const sectionId = event.target.getAttribute('href').substring(1);
        const section = document.getElementById(sectionId);
        if (section) {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY - 38;
            window.scrollTo({
                top: sectionTop,
                behavior: 'smooth',
            });
        }
        setActiveLinkClicked(true); //When Link is clicked then you have to set ActiveClick for close the menu.
    }

    // Function to toggle mobile navigation links
    const toggleLinks = () => {
        // is your links menu is open then your activeClicked must be false.
        setShowLinks(!showLinks);
        setActiveLinkClicked(false);
    }

    return (
        <div>
            <header className={styles.header}>
                <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ""}`}>
                    <div className='container'>
                        <div className={styles['navbar-wrapper']}>
                            <div>
                                <a href="/" className={styles.logo}>
                                    <img src={AppConstants.Images.Logo} alt={InformationData.FirstName + " " + InformationData.LastName} />
                                    <div className={styles['logo-inner']}>
                                        <span className={styles.top}>{InformationData.FirstName + " " + InformationData.LastName}</span>
                                        <br />
                                        <span className={styles.bottom}>{InformationData.Designation}</span>
                                    </div>
                                </a>
                            </div>
                            <div className={`${styles['navbar-links']} ${showLinks ? styles.show : ''}`}>
                                <ul>
                                    {AppConstants.NavLinks.map(link => (
                                        <NavbarLinks key={link.id} href={`#${link.id}`} label={link.label} onClick={handleSectionClick} active={activeSection === link.id} />
                                    ))}
                                </ul>
                            </div>
                            {isMobile && (
                                <div className={`${styles['toggle-button']} ${showLinks ? styles.open : ''}`} onClick={toggleLinks} role="button" tabIndex={0} aria-label="Toggle navigation menu" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleLinks(); }}>
                                    <span className={styles.line}></span>
                                    <span className={styles.line}></span>
                                    <span className={styles.line}></span>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );
};

export default Navbar;

